





























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Product, Element } from '@/models'
import ApiClient from '@/services/api-client'
import { Utils } from '@/utils'
import { MODAL_DELETE_ID } from '@/utils/constants'
import { MutationTypes } from '@/store/mutation-types'
import { ActionTypes } from '@/store/action-types'

@Component({
  components: {
    ModalInfoHeader: () => import('@/containers/ModalInfoHeader.vue')
  }
})
export default class DeleteModal extends Vue {
  @Prop({ required: true }) targetItem: Product | Element

  private itemTitle = ''
  private modalDeleteId = MODAL_DELETE_ID

  private confirmed() {
    return this.targetItem && this.targetItem.name === this.itemTitle
  }

  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent: any, modalId: any) => {
      if (modalId === MODAL_DELETE_ID) {
        this.clearForm()
      }
    })
  }

  private confirmDelete(): void {
    this.itemTitle = ''

    if (Utils.isProduct(this.targetItem)) {
      this.sendDeleteProduct(this.targetItem as Product)
    } else {
      this.sendDeleteElement(this.targetItem as Element)
    }
  }

  private sendDeleteElement(element: Element) {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.deleteElement(element.id)
      .then((deletedElement: Element) => {
        this.$emit('itemDeleted', deletedElement)
        this.hideModal()
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: Error) => {
        this.$store.commit(MutationTypes.SET_LOADING, false)
        if ((ex as any).request.status === 400) {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            variant: 'danger',
            message: `${(ex as any).response.data.message}`
          })
        } else {
          alert(`Error: ${ex.message}`)
        }
      })
  }

  private sendDeleteProduct(product: Product) {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.deleteProduct(product.id)
      .then((deletedProduct: Product) => {
        this.$emit('itemDeleted', deletedProduct)
        this.hideModal()
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: Error) => {
        this.$store.commit(MutationTypes.SET_LOADING, false)
        if ((ex as any).request.status === 400) {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            variant: 'danger',
            message: `${(ex as any).response.data.message}`
          })
        } else {
          alert(`Error: ${ex.message}`)
        }
      })
  }

  clearForm() {
    this.itemTitle = ''
  }

  hideModal() {
    this.clearForm()
    this.$bvModal.hide(MODAL_DELETE_ID)
  }
}
